import { render } from "./BOTBNav.vue?vue&type=template&id=8c3a8254"
import script from "./BOTBNav.vue?vue&type=script&lang=js"
export * from "./BOTBNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__